import { render, staticRenderFns } from "./upgrade-view.vue?vue&type=template&id=463d95d0&"
import script from "./upgrade-view.vue?vue&type=script&lang=ts&"
export * from "./upgrade-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/peter/dev/subscription-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('463d95d0')) {
      api.createRecord('463d95d0', component.options)
    } else {
      api.reload('463d95d0', component.options)
    }
    module.hot.accept("./upgrade-view.vue?vue&type=template&id=463d95d0&", function () {
      api.rerender('463d95d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/upgrade-view.vue"
export default component.exports